import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import theme from './Modal.scss';

let modalRoot = document.getElementById('bol-zelfhulptool');
if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.setAttribute('id', 'modal-root');
    document.body.appendChild(modalRoot);
}

class Modal extends Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        document.body.classList.add('modal-open');
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        document.body.classList.remove('modal-open');
        modalRoot.removeChild(this.el);
    }

    render() {
        const { onClose, styles } = this.props;

        return ReactDOM.createPortal(
            <div className={theme.root} onClick={onClose}>
                <div
                    className={theme.dialog}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    style={styles}
                >
                    {onClose && (
                        <div onClick={onClose} className={theme.closeButton}>
                            <i className="bol-icon-icon_cross" />
                        </div>
                    )}
                    {this.props.children}
                </div>
            </div>,
            this.el
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js